import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHttp } from 'src/hooks';

const TelegramCallback = () => {
  const { sendRequest } = useHttp();
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;

    const params = new URLSearchParams(hash.replace('#', ''));
    const tgAuthResult = params.get('tgAuthResult');

    const urlParams = new URLSearchParams(window.location.search);
    const state = urlParams.get('state');
    if (tgAuthResult && state) {

      fetchTelegramUser(tgAuthResult, state);
    } else {
      console.warn('No tgAuthResult found in the URL.');
    }
  }, []);
  const fetchTelegramUser = (tgAuthResult: string, state: string) => {
    sendRequest(
      {
        url: `telegram/callback?state=${state}`,
        method: 'POST',
        payload: {
          encryptedData: tgAuthResult,
        },
      },
      (data: any) => {

        navigate('/profile');
      },
    );
  };

  return (
    <div>
      <div className="text-white text-center">Redirecting you back to the platform in while...</div>
    </div>
  );
};

export default TelegramCallback;
